// Module
var code = "<template>\n    <select disabled.bind=\"disabled\" class=\"form-control\" ref=\"element\"></select>\n</template>";
// Exports
export default code;